import * as React from 'react';

interface ImageLoaderContextType {
    /**
     * Force all images to be loaded eagerly.
     * Prevent lazy loading.
     */
    forceEagerLoading: boolean;
}

export const ImageLoaderContext = React.createContext<ImageLoaderContextType>({
    forceEagerLoading: false,
});

/**
 * Configure the loading behavior of all images.
 */
export function ImageLoaderProvider(
    props: Partial<ImageLoaderContextType> & { children: React.ReactNode }
) {
    const { children, forceEagerLoading = false } = props;

    const value = React.useMemo(() => {
        return { forceEagerLoading };
    }, [forceEagerLoading]);

    return <ImageLoaderContext.Provider value={value}>{children}</ImageLoaderContext.Provider>;
}
